import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface KeyboardConfig {
  hideNumeric: boolean;
  hideAlphabetic: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class KeyboardConfigService {
  private keyboardConfigSubject = new BehaviorSubject<KeyboardConfig>({
    hideNumeric: false,
    hideAlphabetic: false
  });

  public keyboardConfig$ = this.keyboardConfigSubject.asObservable();

  constructor() {}

  /**
   * Actualiza la configuración de visibilidad de teclados
   * @param config Configuración de teclados desde el API
   */
  updateKeyboardConfig(config: any): void {
    const keyboardConfig: KeyboardConfig = {
      hideNumeric: this.shouldHideKeyboard(config?.OcultarTecladoNumerico),
      hideAlphabetic: this.shouldHideKeyboard(config?.OcultarTecladoAlfanumerico)
    };

    this.keyboardConfigSubject.next(keyboardConfig);
  }

  /**
   * Determina si un teclado debe ocultarse basado en la configuración del API
   * @param configValue Valor de configuración del API ('0', '1', undefined, null)
   * @returns true si debe ocultarse, false si debe mostrarse
   */
  private shouldHideKeyboard(configValue: string | undefined | null): boolean {
    // Si el valor es '1', ocultar el teclado
    // Si el valor es '0', está vacío o no existe, mostrar el teclado
    return configValue === '1';
  }

  /**
   * Obtiene la configuración actual de teclados
   * @returns Configuración actual
   */
  getCurrentConfig(): KeyboardConfig {
    return this.keyboardConfigSubject.value;
  }

  /**
   * Verifica si el teclado numérico debe ocultarse
   * @returns true si debe ocultarse
   */
  shouldHideNumericKeyboard(): boolean {
    return this.keyboardConfigSubject.value.hideNumeric;
  }

  /**
   * Verifica si el teclado alfanumérico debe ocultarse
   * @returns true si debe ocultarse
   */
  shouldHideAlphabeticKeyboard(): boolean {
    return this.keyboardConfigSubject.value.hideAlphabetic;
  }
}
